var map = {
	"./CTGaming.png": "0f29",
	"./J5.webp": "9036",
	"./bg-inner.webp": "97e7",
	"./habanero.png": "c544",
	"./joker.png": "a7b4",
	"./list-livedealer.webp": "1ca6",
	"./lot-01.webp": "74e4",
	"./lot-02.webp": "a71b",
	"./lot-03.webp": "a268",
	"./lot-04.webp": "d539",
	"./new-sport.png": "188c",
	"./pg.png": "58e4",
	"./pragmatic.png": "1487",
	"./redtiger.png": "e5d1",
	"./spadegaming.png": "040f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "785d";